import * as publicActions from './publicActions';
import * as internalActions from './internalActions';
import type { OwaDate } from 'owa-datetime';
import type { IPoint } from '@fluentui/react/lib/Utilities';
import type { QuickAddViewState } from 'owa-todo-views';

/**
 * This is a wrapper around public and internal actions for the `owa-agenda-events` package. It allows
 * pass the scenarioId in once rather than with every action.
 *
 * @param scenarioId the scenarioId for the agenda
 */
export function getScenarioActions(scenarioId: string) {
    if (!scenarioId) {
        throw new Error('The scenarioId should be provided');
    }

    return {
        updateSelectedCalendarEvent: (selectedCalendarEventId: string) =>
            publicActions.updateSelectedCalendarEvent(selectedCalendarEventId, scenarioId),
        updateShouldAutoScroll: (shouldAutoScroll: boolean) =>
            internalActions.updateShouldAutoScroll(shouldAutoScroll, scenarioId),
        onLoadMoreItems: () => internalActions.onLoadMoreItems(scenarioId),
        handleLoadLimitReached: () => internalActions.handleLoadLimitReached(scenarioId),
        scrollToUpNext: () => internalActions.scrollToUpNext(scenarioId),
        scrollToDateHeader: (date: OwaDate) => internalActions.scrollToDateHeader(date, scenarioId),
        scrollToTop: () => internalActions.scrollToTop(scenarioId),
        restoreSavedScrollPosition: () => internalActions.restoreSavedScrollPosition(scenarioId),
        updateTopOfListIndex: (index: number) =>
            internalActions.updateTopOfListIndex(index, scenarioId),
        updateTodoCurrentEditingId: (todoId: string, isEditing: boolean = true) =>
            internalActions.updateCurrentEditingTodoId(todoId, isEditing, scenarioId),
        clickAgendaTodo: (todoId: string) => publicActions.clickAgendaTodo(todoId, scenarioId),
        rightClickAgendaTodo: (todoId: string, anchor: IPoint) =>
            publicActions.rightClickAgendaTodo(todoId, anchor, scenarioId),
        hideTodoContextMenu: () => internalActions.hideTodoContextMenu(scenarioId),
        updateQuickAddViewState: (quickAddViewState: Partial<QuickAddViewState>) =>
            internalActions.updateQuickAddViewState(scenarioId, quickAddViewState),
    };
}
